import { useContext } from 'react'
import { gnarSpec } from '@lib/tracking/gnar'
import { type InteractiveLottiePlayerGnarEvents } from '@components/asset/lottie/hooks/types'
import { PageContext } from '@contexts/page-context'
import { PlacementContext } from '@contexts/placement-context'

export const useInteractiveLottieGnarTracking = () => {
  const { pageId, slug } = useContext(PageContext)
  const { placement, placementInternalName } = useContext(PlacementContext)

  const events: InteractiveLottiePlayerGnarEvents = {
    onAnimationClicked: (segmentIndex, meta) => {
      void gnarSpec.animationInteractiveElementClick(pageId, slug, segmentIndex, meta, placement, placementInternalName)
    },
    onAnimationLoaded: (meta) => {
      void gnarSpec.animationInteractiveElementShow(pageId, slug, meta, placement, placementInternalName)
    },
    onAnimationFinished: () => {
      void gnarSpec.animationInteractiveElementFinish(pageId, slug, placement, placementInternalName)
    },
    onReplayClicked: () => {
      void gnarSpec.animationInteractiveElementReplay(pageId, slug, placement, placementInternalName)
    },
  }

  return events
}
